module.exports = __webpack_public_path__ + "img/icon_3_35.f45748ee.png";